import { JsonObject, JsonProperty } from 'json2typescript';
import * as uuid from 'uuid';

import { Id } from './id';
import { RelativeRelationshipCode, RelativeRelationshipInterface } from '../../../core';
import { RelativeRelationshipCodeAdapter } from '../../client/helpers/serializer/adapters/relative-relationship-code.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('RelativeRelationship')
export class RelativeRelationship implements RelativeRelationshipInterface {
    private readonly _id: Id = undefined;

    @JsonProperty('RelationTypeCode', RelativeRelationshipCodeAdapter, true)
    private _code: RelativeRelationshipCode = undefined;

    @JsonProperty('RelationTypeDescription', StringAdapter, true)
    private _description: string = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Surname', StringAdapter, true)
    private _surname: string = undefined;

    constructor() {
        this._id = Id.fromString(uuid.v4());
    }

    get id(): Id {
        return this._id;
    }

    get code(): RelativeRelationshipCode {
        return this._code;
    }

    set code(value: RelativeRelationshipCode) {
        this._code = value;
    }

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get surname(): string {
        return this._surname;
    }

    set surname(value: string) {
        this._surname = value;
    }

    isComplete(): boolean {
        return !!this.code && !!this.name && !!this.surname;
    }
}
